import React from "react";
import { ListSystemConfig } from "features/SystemConfig";
import { PageContent } from "@redriver/cinnamon";
import { SystemConfigType } from "features/../../../shared/constants/enums";

const ContactDetailsConfigPage = () => (
  <PageContent>
    <ListSystemConfig
      type={SystemConfigType.ContactDetails}
      title="Contact Details"
    />
  </PageContent>
);

export default ContactDetailsConfigPage;
